var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.info
    ? _c(
        "gc-panel",
        {
          staticClass: "card-info",
          attrs: { title: _vm.trans("Giftcard info") }
        },
        [
          _c("gc-list", { attrs: { items: _vm.cardInfoList(_vm.info) } }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "actions" },
            [
              _c("gc-button", {
                attrs: { label: _vm.trans("Check other giftcard") },
                on: {
                  click: function($event) {
                    return _vm.$emit("reset")
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }